export const Types = {
    GET_TOBEPLANNEDS: "GET_TOBEPLANNEDS",
    SET_TOBEPLANNEDS: "SET_TOBEPLANNEDS",

    GET_RECORDSTATUSLIST: "GET_RECORDSTATUSLIST",
    SET_RECORDSTATUSLIST: "SET_RECORDSTATUSLIST",

    GET_TOBEPLANNED_DETAIL_BY_ID: "GET_TOBEPLANNED_DETAIL_BY_ID",
    SET_TOBEPLANNED_DETAIL_BY_ID: "SET_TOBEPLANNED_DETAIL_BY_ID",

    ADD_TOBEPLANNED: "ADD_TOBEPLANNED",
    UPDATE_TOBEPLANNED: "UPDATE_TOBEPLANNED",
    DELETE_TOBEPLANNED: "DELETE_TOBEPLANNED",
    CONVERT_TO_PLANNED_MAINTENANCE: "CONVERT_TO_PLANNED_MAINTENANCE",

    IS_UPDATED_TASK: "IS_UPDATED_TASK",
    RESET_IS_UPDATED_TASK: "RESET_IS_UPDATED_TASK",
};

export const getToBePlanneds = (payload) => ({
    type: Types.GET_TOBEPLANNEDS,
    payload: payload,
});

export const setToBePlanneds = (payload) => ({
    type: Types.SET_TOBEPLANNEDS,
    payload: payload,
});

export const getRecordStatusList = () => ({
    type: Types.GET_RECORDSTATUSLIST,
});

export const setRecordStatusList = (payload) => ({
    type: Types.SET_RECORDSTATUSLIST,
    payload: payload,
});

export const getToBePlannedDetailById = (payload) => ({
    type: Types.GET_TOBEPLANNED_DETAIL_BY_ID,
    payload: payload,
});

export const setToBePlannedDetailById = (payload) => ({
    type: Types.SET_TOBEPLANNED_DETAIL_BY_ID,
    payload: payload,
});

export const addToBePlanned = (payload) => ({
    type: Types.ADD_TOBEPLANNED,
    payload: payload,
});

export const updateToBePlanned = (payload) => ({
    type: Types.UPDATE_TOBEPLANNED,
    payload: payload,
});

export const deleteToBePlanned = (payload) => ({
    type: Types.DELETE_TOBEPLANNED,
    payload: payload,
});

export const convertToPlannedMaintenance = (payload) => ({
    type: Types.CONVERT_TO_PLANNED_MAINTENANCE,
    payload: payload,
});

export const isUpdateTask = (payload) => ({
    type: Types.IS_UPDATED_TASK,
    payload,
});

export const resetIsUpdateTask = (payload) => ({
    type: Types.RESET_IS_UPDATED_TASK,
    payload,
});
